export const SUPPORTED_LANGUAGES = [
  { title: "de", code: "de" },
  { title: "en", code: "en" },
];

export const DEFAULT_LANGUAGE = "de";
